/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unsafe-optional-chaining */
import {
  FormHelperText,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { fetchKpiEntry } from "apis/home";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import MDButton from "components/MDButton";
import MDDatePicker from "components/MDDatePicker";
import Loader from "utils/Loader";
import { displayDate } from "utils/Date";
import { useSelector, useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { postAPICall } from "lib/callApi";
import { FieldArray, Form, Formik } from "formik";
import { UPDATE_PREVIOUS_KPI } from "lib/constants";
import { removeYearFromDateFormat, calculateKpiPoints } from "utils/HelperFunctions";
import OutOfOfficeSwitch from "pages/Widgets/components/OutOfOfficeSwitch";
import { homeAction } from "redux/slice/home";
// import { getFilterDates } from "utils/HelperFunctions";

function UpdateKpiModal(props) {
  const {
    selectedDate,
    open,
    handleClose,
    dateFilter,
    handleCompetitionActivityUpdateOnSuccess,
    isOutOfOfficeDay = false,
  } = props;
  const modelRef = useRef();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.loginUser.loginUserState);
  const [controller] = useMaterialUIController();
  const [kpis, setKpis] = useState();
  const [date, setDate] = useState();
  const [validationError, setValidationError] = useState(false);
  const [errorText, setErrorText] = useState("Please select date");
  const [isLoading, setIsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [httpError, setHttpError] = useState({ error: false, message: "" });
  // const dateRangeFilter = getFilterDates(dateFilter, user.timezone);

  const { darkMode } = controller;

  const handleModalClose = (isSave) => {
    if (!submitLoading) {
      handleClose(isSave);
      setKpis();
      setDate();
      setValidationError(false);
      setErrorText("Please select date");
      setHttpError({ error: false, message: "" });
    }
  };

  const fetchKpis = async (dateRange) => {
    setIsLoading(true);
    setErrorText("Please select date");
    setValidationError(false);
    try {
      const entries = await fetchKpiEntry({
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        timezone: user.timezone,
      });
      if (entries?.data?.success) {
        setKpis(
          entries.data.data.sort((a, b) => {
            if (!a?.sortByOrder && b?.sortByOrder) return 1;
            if (a?.sortByOrder && !b?.sortByOrder) return -1;
            return a.sortByOrder - b.sortByOrder;
          })
        );
        setIsLoading(false);
      } else {
        handleModalClose();
        setIsLoading(false);
        if (entries.response.status !== 403) {
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "Error",
              text: entries?.response?.data?.message || "Something Went Wrong",
            }),
            {
              variant: "custom",
            }
          );
        }
      }
    } catch (err) {
      handleModalClose();
      setIsLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: err?.response?.data?.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  useEffect(() => {
    if (open && (dateFilter === "Today" || selectedDate)) {
      const startDate = moment(selectedDate).startOf("d").format("YYYY-MM-DD HH:mm:ss");
      const endDate = moment(selectedDate).endOf("d").format("YYYY-MM-DD HH:mm:ss");
      if (selectedDate) {
        setDate({
          startDate,
          endDate,
        });
      }
    }
  }, [open]);

  useEffect(() => {
    if (date) fetchKpis(date);
  }, [date]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "80%",
    bgcolor: darkMode ? "#1F283E" : "background.paper",
    overflow: "auto",
    boxShadow: 24,
    p: 4,
    outline: "none",
    borderRadius: "0.5rem",
  };

  const handleSave = async (data) => {
    if (dateFilter !== "Today" && !date) {
      setValidationError(true);
    } else if (dateFilter !== "Today" && !kpis) {
      setValidationError(true);
      setErrorText("Please get kpis before saving");
    } else {
      const updatedKpis = [];

      data.kpis
        .filter((kpi) => {
          const kpi2 = kpis.find((kpi1) => kpi.kpiActionId === kpi1.kpiActionId);
          if (kpi.DailyActions[0].count !== kpi2.DailyActions[0].count) {
            return true;
          }
          return false;
        })
        .forEach((kpi) => {
          updatedKpis.push({
            count: kpi.DailyActions[0].count,
            points: kpi.DailyActions[0].points,
            kpiActionId: kpi.kpiActionId,
            kpiActionName: kpi.KpiActivity.name,
          });
        });

      setSubmitLoading(true);
      try {
        const response = await postAPICall(UPDATE_PREVIOUS_KPI, true, {
          kpis: updatedKpis,
          date:
            dateFilter !== "Today" || selectedDate
              ? moment(date.startDate).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
          timezone: user.timezone,
        });

        if (response?.data?.success) {
          setSubmitLoading(false);
          handleModalClose(true);
          enqueueSnackbar(
            JSON.stringify({
              icon: "success",
              title: "Success",
              text: response?.data?.message,
            }),
            {
              variant: "custom",
            }
          );
          if (handleCompetitionActivityUpdateOnSuccess)
            handleCompetitionActivityUpdateOnSuccess(response.data.data.competition);
        } else {
          setSubmitLoading(false);
          setHttpError({
            error: true,
            message: response?.response?.data?.message || "Something went wrong.",
          });
        }
      } catch (err) {
        setSubmitLoading(false);
        setHttpError({
          error: true,
          message: err?.response?.data?.message || err.message || "Something went wrong",
        });
      }
    }
  };

  const handleKpiChange = (row, count, setFieldValue, index) => {
    setFieldValue(
      `kpis[${index}].DailyActions[0].points`,
      calculateKpiPoints(row.count, row.points, count, row.max_points_per_day)
    );
    setFieldValue(`kpis[${index}].DailyActions[0].count`, count);
  };

  const refetchData = () => {
    dispatch(homeAction.outOfOfficeDayUpdated());
  };

  const handleCreateOutOfOfficeDaysSuccess = async () => {
    refetchData();
    handleModalClose();
  };

  const handleDeleteOutOfOfficeDaysSuccess = async () => {
    refetchData();
    handleModalClose();
  };

  return (
    <Modal
      open={open}
      onClose={() => handleModalClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <MDBox
        sx={{
          ...style,
          width: {
            xs: "90%",
            md: "700px",
          },
        }}
        ref={modelRef}
      >
        <MDBox sx={{ position: "relative" }}>
          <Loader loading={isLoading} />
          <Typography variant="h4" mb={2}>
            Update Kpis{" "}
            {!dateFilter && selectedDate
              ? `: ${moment.tz(selectedDate, user.timezone).format("dddd")} ${moment
                  .tz(selectedDate, user.timezone)
                  .format(removeYearFromDateFormat(user.dateFormat))}`
              : ""}
          </Typography>
          {dateFilter !== "Today" && !selectedDate && (
            <Stack direction="row" spacing={2} my={3}>
              <Stack>
                <MDDatePicker
                  input={{ placeholder: "Select a date" }}
                  options={{
                    parseDate: (datestr, format) => moment(datestr, format, true)?._d,
                    formatDate: (rawDate) => displayDate(rawDate, user?.dateFormat),
                    // eslint-disable-next-line no-underscore-dangle
                    // minDate: moment.tz(dateRangeFilter.startDate, user.timezone)?._d,
                    maxDate: moment.tz(undefined, user.timezone)?.toDate(),
                    disableMobile: "true",
                  }}
                  onChange={(value) => {
                    setValidationError(false);
                    const dateObj = {
                      startDate: moment(value[0]).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
                      endDate: moment(value[0]).endOf("d").format("YYYY-MM-DD HH:mm:ss"),
                    };
                    setDate(dateObj);
                  }}
                />
                {validationError && (
                  <FormHelperText sx={{ color: "#d32f2f" }}>{errorText}</FormHelperText>
                )}
              </Stack>
            </Stack>
          )}
          {!(dateFilter !== "Today" && !kpis) && (
            <MDBox sx={{ position: "relative" }}>
              <Formik enableReinitialize initialValues={{ kpis }} onSubmit={handleSave}>
                {({ values, setFieldValue, dirty }) => (
                  <Form>
                    <TableContainer
                      component={Paper}
                      sx={{
                        maxHeight: window.innerHeight < 800 ? 320 : 450,
                        userSelect: "none",
                        boxShadow: "none",
                        borderRadius: 0,
                      }}
                    >
                      <Table aria-label="simple table">
                        <TableHead sx={{ display: "table-header-group" }}>
                          <TableRow>
                            <TableCell width="350px">KPIs</TableCell>
                            <TableCell align="center">Completed</TableCell>
                            <TableCell align="center" width="200px">
                              Achieved Points
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <FieldArray
                            name="kpis"
                            render={() => (
                              // eslint-disable-next-line react/jsx-no-useless-fragment
                              <>
                                {values?.kpis?.map((row, index) => (
                                  <TableRow key={row.id} hover>
                                    <TableCell sx={{ padding: "0.4rem 1rem" }}>
                                      {row?.KpiActivity?.name}
                                    </TableCell>
                                    <TableCell
                                      sx={{ padding: "0.4rem 1rem" }}
                                      width="200px"
                                      align="center"
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                        width="150px"
                                      >
                                        {!row.isKpiLocked ? (
                                          <RemoveIcon
                                            sx={{ cursor: "pointer" }}
                                            onClick={() => {
                                              if (row?.DailyActions[0]?.count - 1 >= 0) {
                                                handleKpiChange(
                                                  row,
                                                  row?.DailyActions[0]?.count - 1,
                                                  setFieldValue,
                                                  index
                                                );
                                              }
                                            }}
                                          />
                                        ) : null}
                                        <TextField
                                          type="number"
                                          value={row?.DailyActions[0]?.count.toString()}
                                          inputProps={{ style: { textAlign: "center" } }}
                                          disabled={row.isKpiLocked}
                                          sx={{
                                            "& input[type=number]": {
                                              MozAppearance: "textfield",
                                              height: ".8em",
                                            },
                                            "& input[type=number]::-webkit-outer-spin-button": {
                                              WebkitAppearance: "none",
                                              margin: 0,
                                            },
                                            "& input[type=number]::-webkit-inner-spin-button": {
                                              WebkitAppearance: "none",
                                              margin: 0,
                                            },
                                          }}
                                          onChange={(event) => {
                                            if (event.target.value < 0) return;

                                            if (parseInt(event.target.value || 0, 10) <= 999) {
                                              handleKpiChange(
                                                row,
                                                parseInt(event.target.value || 0, 10),
                                                setFieldValue,
                                                index
                                              );
                                            }
                                          }}
                                        />
                                        {!row.isKpiLocked ? (
                                          <AddIcon
                                            sx={{ cursor: "pointer" }}
                                            onClick={() => {
                                              if (row?.DailyActions[0]?.count + 1 <= 999) {
                                                handleKpiChange(
                                                  row,
                                                  row?.DailyActions[0]?.count + 1,
                                                  setFieldValue,
                                                  index
                                                );
                                              }
                                            }}
                                          />
                                        ) : null}
                                      </Stack>
                                    </TableCell>
                                    <TableCell sx={{ padding: "0.4rem 1rem" }} align="center">
                                      {parseInt(row?.DailyActions[0]?.points, 10)}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </>
                            )}
                          />
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {httpError.error && (
                      <MDBox
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "#d32f2f",
                            fontSize: "16px",
                            mt: 2,
                            pl: 1,
                          },
                        }}
                      >
                        {" "}
                        <FormHelperText>{httpError.message}</FormHelperText>
                      </MDBox>
                    )}
                    <MDBox
                      sx={{ display: "flex", justifyContent: "end", alignItems: "center", mt: 1 }}
                    >
                      <OutOfOfficeSwitch
                        alertTarget={modelRef?.current}
                        isOutOfOfficeDay={isOutOfOfficeDay}
                        selectedDate={date?.startDate || selectedDate}
                        setIsLoading={setIsLoading}
                        handleCreateOutOfOfficeDaysSuccess={handleCreateOutOfOfficeDaysSuccess}
                        handleDeleteOutOfOfficeDaysSuccess={handleDeleteOutOfOfficeDaysSuccess}
                      />
                      <MDButton
                        color="gray80"
                        onClick={() => handleModalClose()}
                        sx={{ mt: 1, mr: 1, position: "relative" }}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        color="primaryRed"
                        type="submit"
                        sx={{ mt: 1, position: "relative" }}
                        disabled={submitLoading || !dirty}
                        // onClick={handleSave}
                      >
                        {!submitLoading ? "Save" : "Loading..."}
                      </MDButton>
                    </MDBox>
                  </Form>
                )}
              </Formik>
            </MDBox>
          )}
          {dateFilter !== "Today" && !kpis && (
            <MDBox sx={{ display: "flex", justifyContent: "end", mt: 1 }}>
              <MDButton
                color="gray80"
                onClick={() => handleModalClose()}
                sx={{ mt: 2, mr: 1, position: "relative" }}
              >
                Cancel
              </MDButton>
            </MDBox>
          )}
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default UpdateKpiModal;
